module.exports = __webpack_public_path__ + "img/carrousel-video-2.7dce5b12.png";